/** Locales the product ships with (D-020). Brands choose a subset (D-021). */
export const supportedLocales = ['en-CA', 'fr-CA', 'en-US', 'es-US'] as const;
export type Locale = (typeof supportedLocales)[number];

/** Every other locale must have exactly this one's keys (resources.ts). */
export const referenceLocale: Locale = 'en-CA';

/**
 * Each language's name in its own language, for the language switcher.
 * Deliberately not translated: people look for their own language's name.
 */
export const localeNames: Readonly<Record<Locale, string>> = {
  'en-CA': 'English (Canada)',
  'fr-CA': 'Français (Canada)',
  'en-US': 'English (US)',
  'es-US': 'Español (US)',
};

export function isSupportedLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (supportedLocales as readonly string[]).includes(value);
}
